module.exports = __webpack_public_path__ + "static/st.3-4eb9275ae84306704910b0138583dd9a.png";